import { useEffect, useState } from "react";

/**
 * A once-a-minute wall-clock reading, in epoch seconds — so time-relative UI (late/upcoming/elapsed
 * badges) ticks forward without a refetch, and WITHOUT calling `Date.now()` directly during render
 * (react-compiler's react(purity) rule: impure calls may not run in the render body). The initial value
 * is a `useState` LAZY INITIALIZER, which React runs exactly once on mount — safe under the same rule —
 * and subsequent ticks come from a real effect (an external system: the wall clock).
 */
export function useMinuteClock(): number {
  const [nowSec, setNowSec] = useState(() => Math.floor(Date.now() / 1000));
  useEffect(() => {
    const id = setInterval(() => setNowSec(Math.floor(Date.now() / 1000)), 60_000);
    return () => clearInterval(id);
  }, []);
  return nowSec;
}
